import { ref as a, onMounted as i, onUnmounted as v } from "vue";
function f(r, d = { manual: !1 }) {
  const n = a(null), t = a(!1), o = a(null), l = () => t.value = !0, u = (e) => o.value = e.error;
  function c() {
    let e = document.querySelector(`script[src="${r}"]`);
    e ? t.value = !0 : (t.value = !1, o.value = null, e = document.createElement("script"), e.type = "text/javascript", e.async = !0, e.src = r, e.addEventListener("load", l), e.addEventListener("error", u), document.head.appendChild(e)), n.value = e;
  }
  function s() {
    if (!document)
      return;
    const e = document.querySelector(`script[src="${r}"]`);
    e && (e.removeEventListener("load", l), e.removeEventListener("error", u), document.head.removeChild(e), n.value = null, t.value = !1);
  }
  return d.manual || (i(c), v(s)), { scriptTag: n, load: c, unload: s, isLoaded: t, error: o };
}
export {
  f as default
};
//# sourceMappingURL=useScriptTag.js.map
